const disabledDisplayTypes = new Set<ListViewDisplay>(['inbox', 'kanban', 'calendar'])

export function isFieldEditorEnabledForDisplay(display: ListViewDisplay): boolean {
    return !disabledDisplayTypes.has(display)
}
